import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { IQueryParams, createEntitySlice, EntityState, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { IKpiPresetVehicle, defaultValue } from 'app/shared/model/kpi-preset-vehicle.model';

const initialState: EntityState<IKpiPresetVehicle> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const apiUrl = 'api/kpi-preset-vehicles';

// Actions

export const getEntitiesByPreset = createAsyncThunk(
  'kpiPresetVehicle/fetch_entity_list_by_preset',
  async (params: { presetId?: number | null; companyId?: number | null }) => {
    const { presetId, companyId } = params;
    const presetParam = presetId !== undefined && presetId !== null ? presetId : 'null';

    let requestUrl = `${apiUrl}/preset/${presetParam}`;

    if (companyId !== null && companyId !== undefined) {
      requestUrl += `?companyId=${companyId}`;
    }

    return axios.get<IKpiPresetVehicle[]>(requestUrl);
  }
);

// slice

export const KpiPresetVehicleSlice = createEntitySlice({
  name: 'kpiPresetVehicle',
  initialState,
  extraReducers(builder) {
    builder
      .addMatcher(isFulfilled(getEntitiesByPreset), (state, action) => {
        return {
          ...state,
          loading: false,
          entities: action.payload.data,
        };
      })
      .addMatcher(isPending(getEntitiesByPreset), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      });
  },
});

export const { reset } = KpiPresetVehicleSlice.actions;

// Reducer
export default KpiPresetVehicleSlice.reducer;
